"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VsmLastSentAlertDto = void 0;
const VehicleDropOffDto_1 = require("../vehicle-drop-offs/VehicleDropOffDto");
class VsmLastSentAlertDto {
    constructor(params) {
        this.alertType = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.vehicleDropOffId = params.vehicleDropOffId;
        this.alertType = params.alertType;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.vehicleDropOff !== undefined) {
            this.vehicleDropOff = params.vehicleDropOff ? new VehicleDropOffDto_1.VehicleDropOffDto(params.vehicleDropOff) : null;
        }
    }
}
exports.VsmLastSentAlertDto = VsmLastSentAlertDto;
//# sourceMappingURL=VsmLastSentAlertDto.js.map